import { render, staticRenderFns } from "./tenthConsumerList.vue?vue&type=template&id=3fd62330&scoped=true"
import script from "./tenthConsumerList.vue?vue&type=script&lang=js"
export * from "./tenthConsumerList.vue?vue&type=script&lang=js"
import style0 from "./tenthConsumerList.vue?vue&type=style&index=0&id=3fd62330&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd62330",
  null
  
)

export default component.exports